import { useRadioGroupContext } from "@/RadioGroup/RadioGroupContext";
import { useRadioIndex } from "@/RadioGroup/RadioIndexContext";
import { Radio as BaseRadio } from "@base-ui-components/react/radio";
import { ReactNode } from "react";
import {
  radioIndicatorClasses,
  radioLabelClasses,
  radioRightIconClasses,
  radioRootClasses,
} from "./Radio.style";
import { CheckCircleIcon } from "@spoctech/icons";
import { Field } from "@base-ui-components/react/field";
type RadioProps = BaseRadio.Root.Props & {
  label?: string | ReactNode;
  description?: string | ReactNode;
};
const Radio = ({ label, description, ...rest }: RadioProps) => {
  const index = useRadioIndex();
  const { variant, variantOptionLabel } = useRadioGroupContext();
  const optionCountChar =
    variantOptionLabel === "number"
      ? index + 1
      : String.fromCharCode(65 + index);

  return (
    <Field.Label
      className={radioLabelClasses({ variant, class: "min-h-[2.625rem]" })}
    >
      <BaseRadio.Root {...rest} className={radioRootClasses({ variant })}>
        <BaseRadio.Indicator
          className={radioIndicatorClasses({ variant })}
          keepMounted
          render={(props) => {
            if (variant === "options") {
              return <span {...props}>{optionCountChar}</span>;
            }
            return <span {...props} />;
          }}
        />
      </BaseRadio.Root>
      <span className="flex-grow">
        <span>{label}</span>
        {description && (
          <span className="text-sm text-gray-500 block">{description}</span>
        )}
      </span>
      {variant === "options" && (
        <span className={radioRightIconClasses({})}>
          <CheckCircleIcon />
        </span>
      )}
    </Field.Label>
  );
};

export default Radio;
